import React, { useEffect, useState } from "react";
import { apiErrorMessage, getTaskTimeLock, lockTaskTime } from "../../api";

const DATE_FMT = { month: "short", day: "numeric", year: "numeric" };

// The task page's line about whether time can still go on this file, and the
// "Lock time now" button. A roll-forward leaves the year open for late time
// for 3 months (owner, 2026-10-27); this ends that early. The lock is per
// client and year, so it shuts every category's time for that year.
//
// `refreshKey` changes when the task does (a completion or a roll), so the
// state is re-read rather than left describing the file as it was.
export default function TimeLockControl({ task, refreshKey }) {
  const [lock, setLock] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!task?.fiscal_year) return undefined;
    let live = true;
    getTaskTimeLock(task.id)
      .then((r) => { if (live) setLock(r); })
      .catch(() => { if (live) setLock(null); });
    return () => { live = false; };
  }, [task?.id, task?.fiscal_year, refreshKey]);

  if (!task?.fiscal_year || !lock) return null;

  const year = task.fiscal_year;
  const onLock = async () => {
    if (!window.confirm(
      `Lock time for ${year}? Nobody will be able to add or change time ` +
      `for this client's ${year} year or earlier, on any task.`)) return;
    setBusy(true);
    setError("");
    try {
      setLock(await lockTaskTime(task.id));
    } catch (e) {
      setError(apiErrorMessage(e, "Could not lock time."));
    } finally {
      setBusy(false);
    }
  };

  const text = lock.state === "locked"
    ? `🔒 Time is locked for ${year}.`
    : lock.state === "pending"
      ? `Rolled forward. Time can still be entered until ${
        new Date(lock.locks_at).toLocaleDateString("en-US", DATE_FMT)}, then ${year} locks.`
      : `Time is open for ${year}.`;

  return (
    <div data-testid="time-lock" style={{
      display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap",
      fontSize: 13, color: lock.state === "locked" ? "#6b7280" : "#374151",
    }}>
      <span>{text}</span>
      {lock.state !== "locked" && (
        <button onClick={onLock} disabled={busy} style={{
          padding: "6px 14px", background: "white", color: "#b91c1c",
          border: "1px solid #b91c1c", borderRadius: 6, fontSize: 13, fontWeight: 600,
          cursor: busy ? "wait" : "pointer",
        }}>
          {busy ? "Locking…" : "Lock time now"}
        </button>
      )}
      {error && <span style={{ color: "#b91c1c" }}>{error}</span>}
    </div>
  );
}
